<template>
  <button class="backpack vibration" @click="showSchoolTestModal">
  </button>
</template>

<script>
import { mapActions } from "vuex"

export default {
  name: "backpack-btn",
  methods: {
    ...mapActions('modal', [
        'modalType_schoolTest'
    ]),
    showSchoolTestModal() {
      this.modalType_schoolTest({})
    }
  }
}
</script>


<style lang="sass">
@keyframes backpack-vibration
  0%, 100%
    transform: translate(0, 0)
  2%
    transform: translate(-1px, 1px)
  4%
    transform: translate(1px, -1px)
  6%
    transform: translate(-1px, 1px)
  8%
    transform: translate(1px, -1px)
  10%
    transform: translate(-1px, 1px)
  12%
    transform: translate(0, 0)
  25%, 100%
    transform: translate(0, 0)

.backpack
  position: relative
  width: 47px
  height: 51px
  background-image: url("/dist/img/school-test/backpack.svg")
  background-repeat: no-repeat
  object-fit: contain

  &.vibration
    animation: backpack-vibration 4s ease-in-out infinite
</style>


// WEBPACK FOOTER //
// src/templates/components/base/header/school-test/components/backpack-btn.vue